const SMART_TAG_ADAPTER = {
    NAMESPACE: 'SMART_TAG_ADAPTER',
    INIT: 'INITIALIZATION',
    SPA_LOAD: 'SPA_LOAD',
};

export { SMART_TAG_ADAPTER };
